import {
    SET_EMBEDDED_BOOKING_CARDATA,
    SET_EMBEDDED_BOOKING_OTHERINFO,
    SET_EMBEDDED_BOOKING_CONTACTINFO,
    SET_EMBEDDED_BOOKING_DATA,
    SET_EMBEDDED_INSURANCE_COMPANIES,
    SET_EMBEDDED_CARRENTAL_ALTERNATIVES
} from '../constants'

const initialState = {
  IsComplete: false,
  CurrentStep: 0,
  CarData: {
    RegNumber: '',
    BrandName: '',
    Model: '',
    ChassisNumber: '',
    Km: 0,
    DamageComment: ''
  },
  FilesInfo: { Files: [] },
  OtherInfo: {
    DamageNr: '',
    InsuranceCompanyId: 0,
    NeedRental: false,
    CarRentalId: 0,
    DamageDate: null
  },
  ContactInfo: {},
  InsuranceCompanies: [],
  CarRentalAlternatives: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_EMBEDDED_BOOKING_CARDATA:
      return {
        ...state,
        CarData: action.carData
      }
    case SET_EMBEDDED_BOOKING_OTHERINFO:
      return {
        ...state,
        OtherInfo: action.otherInfo
      }
    case SET_EMBEDDED_BOOKING_CONTACTINFO:
      return {
        ...state,
        ContactInfo: action.contactInfo
      }
    case SET_EMBEDDED_BOOKING_DATA:
      return {
        ...state,
        ...action.data
      }
    case SET_EMBEDDED_INSURANCE_COMPANIES:
      return {
        ...state,
        InsuranceCompanies: action.insuranceCompanies
      }
    case SET_EMBEDDED_CARRENTAL_ALTERNATIVES:
      return {
        ...state,
        CarRentalAlternatives: action.carRentalAlts
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/embeddedbooking.js